export default __webpack_public_path__ + "static/media/icons8-maintenance-100.c54286fa.svg";